/* Header search: live product suggestions + search row toggle (2026-10-14) */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function money(p){var n=parseFloat(p);return isNaN(n)?'':'£'+n.toFixed(2)}

  document.querySelectorAll('[data-psearch]').forEach(function(form){
    var input=form.querySelector('input[name="q"]'),box=form.querySelector('.ps-results');
    var url=form.getAttribute('data-ps-url')||'/search/suggest',timer,ctrl,last='';
    if(!input||!box)return;
    function hide(){box.hidden=true}
    function run(){
      var q=input.value.trim();
      if(q.length<2){hide();last='';return}
      if(q===last){box.hidden=false;return}
      last=q;
      if(ctrl)ctrl.abort();
      ctrl=window.AbortController?new AbortController():null;
      var qs='q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6'+
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag,variants.title';
      fetch(url+'.json?'+qs,{signal:ctrl?ctrl.signal:undefined})
        .then(function(r){return r.json()})
        .then(function(d){
          if(input.value.trim()!==q)return;
          var ps=(d.resources&&d.resources.results&&d.resources.results.products)||[];
          var all=form.getAttribute('action')+'?type=product&options%5Bprefix%5D=last&q='+encodeURIComponent(q);
          if(!ps.length){
            box.innerHTML='<div class="ps-empty">No fabrics match &ldquo;'+esc(q)+'&rdquo;. Try another word.</div>';
          }else{
            box.innerHTML=ps.map(function(p){
              var img=(p.featured_image&&p.featured_image.url)||p.image||'';
              if(img)img+=(img.indexOf('?')>-1?'&':'?')+'width=120';
              return '<a class="ps-item" href="'+esc(p.url)+'">'+
                (img?'<img src="'+esc(img)+'" alt="" loading="lazy" width="48" height="48">':'<span class="ps-noimg"></span>')+
                '<span class="ps-t">'+esc(p.title)+'</span>'+
                '<span class="ps-p">'+money(p.price)+(p.available===false?'<em>Sold out</em>':'')+'</span></a>';
            }).join('')+'<a class="ps-all" href="'+esc(all)+'">See all results for &ldquo;'+esc(q)+'&rdquo; &rarr;</a>';
          }
          box.hidden=false;
        }).catch(function(){});
    }
    input.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(run,180)});
    input.addEventListener('focus',function(){if(input.value.trim().length>1)run()});
    input.addEventListener('keydown',function(e){if(e.key==='Escape'){hide();input.blur()}});
    document.addEventListener('click',function(e){if(!form.contains(e.target))hide()});
  });

  var row=document.getElementById('MobileSearch');
  var toggles=document.querySelectorAll('[data-search-toggle]');
  if(row){
    toggles.forEach(function(btn){
      btn.addEventListener('click',function(){
        var open=row.hidden;
        row.hidden=!open;
        toggles.forEach(function(b){b.setAttribute('aria-expanded',open?'true':'false')});
        if(open){var i=row.querySelector('input[name="q"]');if(i)i.focus()}
      });
    });
  }
})();
